export default "__VITE_ASSET__283ac579__"